import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { LOGO_URL } from "@/lib/constants";
import { useCurrency } from "@/context/CurrencyContext";

export default function AppHeader({ title, showBack = false, showLogo = true }) {
  const navigate = useNavigate();
  const { currency, toggle } = useCurrency();
  return (
    <header className="sticky-header px-4 py-3 flex items-center gap-3" data-testid="app-header">
      {showBack && (
        <button
          onClick={() => navigate(-1)}
          data-testid="header-back-btn"
          className="w-9 h-9 rounded-full flex items-center justify-center hover:bg-slate-100 active:scale-95 transition"
        >
          <ArrowLeft size={20} className="text-[#0A2A66]" />
        </button>
      )}
      {showLogo && !showBack && (
        <img src={LOGO_URL} alt="NEO ACADEMY" className="h-9 w-9 object-contain" />
      )}
      <h1 className="font-heading text-lg font-bold text-[#0A2A66] flex-1 truncate">{title}</h1>
      <button
        onClick={toggle}
        data-testid="currency-toggle"
        className="text-xs font-semibold px-3 py-1.5 rounded-full bg-[#EEF3FF] text-[#0A2A66] hover:bg-[#dfe8ff] transition"
      >
        {currency}
      </button>
    </header>
  );
}
